export enum PolicyType {
  privacyPolicy = 'privacyPolicy',
  termsAndConditions = 'termsAndConditions',
}

export type PolicyEntity = {
  type: PolicyType;
  content: string;
};
